<template>


  <div class="col">
    <label class="form-label">지역</label>
    <div class="p-autocomplete-wrap p-autocomplete-region">
      <AutoComplete
          v-model="selectedRegionIpt"
          :suggestions="filteredRegionList"
          @blur="handleRegionBlur"
          @item-select="handleItemSelect"
          @complete="filterRegions"
          @show="handleDropdownShow"
          dropdown
          force-selection
      />
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {searchBarProps} from "@/store";

const emit = defineEmits(['loading']);
const props = defineProps({
})
const store = useStore();
const patchSearchBar = (data) => store.dispatch('patchSearchBar', data);

// 변수
const settings = computed(() => store.state.searchBar.settings);
const selectedRegion = computed(() => store.state.searchBar.selectedRegion);
const regionList = computed(() => {
  return store.state.searchBar.regionList;
});
const selectedRegionIpt = ref(selectedRegion.value);
const filteredRegionList = ref([]);

// Methods
function filterRegions(event) {
  const query = event.query.toLowerCase();
  filteredRegionList.value = regionList.value.filter(item =>
      item.toLowerCase().includes(query)
  );
}

function handleRegionBlur() {
  if (selectedRegionIpt.value === null) {
    selectedRegionIpt.value = regionList.value[0];
    patchSearchBar({
      prop: searchBarProps.selectedRegion,
      value: selectedRegionIpt.value,
    });
  }
}

function handleDropdownShow(evt) {
  const targetEl = window.document.querySelector('.p-autocomplete-items .p-highlight')
  if (targetEl) {
    targetEl.scrollIntoView({block: 'center'});
  }
}

function handleItemSelect({value}) {
  patchSearchBar({
    prop: searchBarProps.selectedRegion,
    value,
  });
}

watch(
    selectedRegion,
    (after, _) => {
      selectedRegionIpt.value = after;
    }
)

</script>

<style>
.p-autocomplete-region .p-autocomplete .p-autocomplete-input {
  width: 100px;
}
</style>
